// EmptyState.js
import React from 'react';
import './EmptyStateInAppNotifications.scss'; // Optional: add custom styles
import { FormattedMessage, injectIntl } from 'react-intl';

const EmptyStateInAppNotifications = () => {
    const noNotificationsEmptyStateCopy = (<FormattedMessage id="EmptyState.notificationsTitle" defaultMessage="All caught up! New activity will appear here." />);
    return (
        <div className="empty-state">
            <div className="bell-icon">
                <img src="/icons/placeholder-notification-icon.svg" alt="No Notifications" />
            </div>
            <p>{noNotificationsEmptyStateCopy}</p>
        </div>
    );
};

export default injectIntl(EmptyStateInAppNotifications);
